import { VuetifyConfirmObject } from 'vuetify-confirm'
import { WrongAnswerNoteOVO, QuestionType } from '@/views/biz/note/vo/WrongAnswerNote.vo'

export default class CommonUtils {
  static baseConfirmOption: VuetifyConfirmObject = {
    buttonTrueText: '확인',
    buttonFalseText: '취소',
    color: 'primary',
    icon: 'warning',
    width: 350
  }

  static getNumberPad(n, width) {
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n;
  }

  /**
   * 로컬 스토리지 객체 취득
   * @param key 
   */
  static getLocalStorageObject<T>(key: string): T{
    const val: T = JSON.parse( localStorage.getItem(key) || '{}' );
    return val;
  }

  /**
   * 로컬 스토리지 객체 저장
   * @param key 
   * @param val 
   */
  static putLocalStorageObject(key: string, val: object): void{
    localStorage.setItem(key , JSON.stringify(val));
  }

  /**
   * 오답노트 문제 유형
   * @param item 
   */
  static getQuestionType(item: WrongAnswerNoteOVO): QuestionType {
    const result = {} as QuestionType;

    if(10 >= item.crtAnsrPctg) {
      result.name = '모르는 문제';
      result.type = 'unknown';
      result.color = '#E46651';
    }

    if(10 < item.crtAnsrPctg && 95 > item.crtAnsrPctg) {
      result.name = '애매모호한 문제';
      result.type = 'ambiguous';
      result.color = '#41B883';
    }

    if(95 <= item.crtAnsrPctg) {
      result.name = '아는 문제';
      result.type = 'known';
      result.color = 'rgb(0 178 210)';
    }
    return result;
  }

  // 앱임?
  static isApp(): boolean {
    return window['ReactNativeWebView'] ? true : false;
  }

}